import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";

import { MODE_ORGANIZER, useMode } from "../constants/ModeProvider";

// Blocks a route unless the session is in organizer mode. This enforces the
// mode boundary at the route level (not just hiding nav): a developer-mode user
// who navigates straight to an organizer URL is redirected away. The backend
// still guards the organizer APIs (IsOrganizerMode), so this is defense in UI.
export default function RequireOrganizerMode({ children }) {
  const { mode, loading } = useMode();
  if (loading) return null;
  if (mode !== MODE_ORGANIZER) return <Navigate replace to="/leaderboard" />;
  return children;
}

RequireOrganizerMode.propTypes = {
  children: PropTypes.node,
};
